/* ===========================================================================
   FRAMESI · Diagnóstico — motor

   Implementa literalmente la regla de evaluación que declara el propio archivo
   de reglas: «por cada paso se recorren las reglas EN ORDEN; la primera que se
   cumple gana y se deja de evaluar ese paso».

   Tres cosas que NO hace, a propósito:
   · No inventa producto. Si ningún paso casa, ese paso no aparece.
   · No recomienda lo que no se puede comprar: un SKU agotado se muestra como
     agotado y se excluye del botón de «añadir la rutina».
   · No pide datos personales.

   Guarda de inicialización única: si dos secciones cargaran este asset, cada
   clic contaría doble y el cuestionario avanzaría de dos en dos.
   ======================================================================== */
(function () {
  'use strict';
  if (window.__fxDiagnostico) return;
  window.__fxDiagnostico = true;

  var raiz = document.querySelector('[data-diagnostico]');
  if (!raiz) return;

  var PRODUCTOS = {};
  try {
    PRODUCTOS = JSON.parse(raiz.querySelector('[data-dx-productos]').textContent);
  } catch (e) {
    console.warn('Diagnóstico: no se pudo leer el catálogo', e);
  }

  var REGLAS = null;
  var respuestas = {};
  var indice = 0;

  var intro = raiz.querySelector('[data-dx-intro]');
  var panel = raiz.querySelector('[data-dx-panel]');
  var resultado = raiz.querySelector('[data-dx-resultado]');
  var elPregunta = raiz.querySelector('[data-dx-pregunta]');
  var elOpciones = raiz.querySelector('[data-dx-opciones]');
  var elContador = raiz.querySelector('[data-dx-contador]');
  var elProgreso = raiz.querySelector('[data-dx-progreso]');
  var elAtras = raiz.querySelector('[data-dx-atras]');

  function ver(el, visible) {
    if (!el) return;
    if (visible) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
  }

  /* ---- preguntas activas -------------------------------------------------
     La 7ª sólo existe si la respuesta de cuero cabelludo la activa. Todo lo que
     cuenta pasos usa ESTA lista, nunca la lista completa: si no, el contador
     dice «Paso 5 de 7» cuando en realidad son 6. */
  function activas() {
    if (!REGLAS) return [];
    return REGLAS.preguntas.filter(function (q) {
      if (!q.solo_si) return true;
      var v = respuestas[q.solo_si.campo];
      return v && q.solo_si.en.indexOf(v) >= 0;
    });
  }

  function cumple(cond) {
    var v = respuestas[cond.campo];
    if (v === undefined) return false;
    return cond.en.indexOf(v) >= 0;
  }

  function reglaAplica(r) {
    if (r.default) return true;
    if (r.todos) return r.todos.every(cumple);
    if (r.alguno) return r.alguno.some(cumple);
    return false;
  }

  // Hay existencia si se puede vender el tamaño normal o el de 1 L.
  function hayExistencia(p) {
    return !!p && (!!p.disponible || !!(p.grande && p.grande.disponible));
  }

  function resolver() {
    var pasos = [];
    Object.keys(REGLAS.pasos).forEach(function (clave) {
      var lista = REGLAS.pasos[clave];
      for (var i = 0; i < lista.length; i++) {
        if (reglaAplica(lista[i])) {
          var regla = lista[i];
          // Si lo que pide el protocolo está agotado, se usa el producto general del paso.
          // Si ese también está agotado, el paso no se muestra.
          if (!hayExistencia(PRODUCTOS[regla.sku])) {
            regla = lista.filter(function (r) { return r.default && hayExistencia(PRODUCTOS[r.sku]); })[0];
            if (!regla) return;
          }
          var sku = regla.sku;
          var p = PRODUCTOS[sku];
          pasos.push({ clave: clave, sku: sku, producto: p, nota: regla.nota || '' });
          return;               // la primera que se cumple gana
        }
      }
    });
    return pasos;
  }

  var ROTULOS = {
    paso_1_pre_shampoo: 'Antes del shampoo',
    paso_2_shampoo: 'Shampoo',
    paso_3_tratamiento: 'Tratamiento',
    paso_4_acabado: 'Acabado'
  };

  /* ---- pintar una pregunta ---- */
  var ETIQUETAS = { 'Frenar la caída': 'Caída del cabello (no patológica)' };

  function pintar() {
    var lista = activas();
    if (indice >= lista.length) return mostrarResultado();

    var q = lista[indice];
    elContador.textContent = 'Paso ' + (indice + 1) + ' de ' + lista.length;
    elProgreso.style.width = ((indice) / lista.length * 100).toFixed(1) + '%';
    elPregunta.textContent = q.pregunta;
    ver(elAtras, indice > 0);

    elOpciones.setAttribute('role', 'radiogroup');
    elOpciones.setAttribute('aria-label', q.pregunta);
    elOpciones.innerHTML = '';
    q.opciones.forEach(function (op) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fx-dx__op' + (respuestas[q.campo] === op ? ' esta-elegida' : '');
      /* Etiqueta VISIBLE distinta del valor interno. «Frenar la caída» es el valor que
         usan las reglas del técnico (diagnostico-reglas.json) y las 2,400 filas del CSV
         de referencia: cambiarlo ahí rompería el verificador de 16,800 combinaciones.
         Pero como texto es una promesa sobre la caída, prohibida (COFEPRIS). Se muestra
         una frase sin promesa y el motor sigue viendo el mismo valor. */
      b.textContent = ETIQUETAS[op] || op;
      /* Es una opción de una lista, no un interruptor: `aria-pressed` le decía al
         lector de pantalla «botón, no presionado» en las siete respuestas. */
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', respuestas[q.campo] === op ? 'true' : 'false');
      b.addEventListener('click', function () {
        respuestas[q.campo] = op;
        /* si cambia una respuesta que habilita otra pregunta, las de más
           adelante dejan de ser válidas y se limpian */
        if (q.cambia) {
          REGLAS.preguntas.forEach(function (otra) {
            if (otra.solo_si && otra.solo_si.campo === q.campo) delete respuestas[otra.campo];
          });
        }
        indice += 1;
        pintar();
      });
      elOpciones.appendChild(b);
    });
    elPregunta.focus();
  }

  /* ---- estado de presentación por paso ------------------------------------
     'normal' = el tamaño que manda el protocolo · 'grande' = el mismo producto
     en 1 L. Es SUSTITUCIÓN: nunca se añaden los dos. */
  var eleccion = {};
  var kitPuesto = false;
  var pasosActuales = [];

  function ml(t) {
    if (!t) return null;
    var m = /^\s*([\d.,]+)\s*(ML|L|G|KG)\s*$/i.exec(t);
    if (!m) return null;
    var v = parseFloat(m[1].replace(',', '.'));
    var u = m[2].toUpperCase();
    return (u === 'L' || u === 'KG') ? v * 1000 : v;
  }

  /* ¿cuántas veces más producto trae el grande? Se calcula, no se afirma de
     memoria: si mañana cambia un tamaño, el texto cambia con él. */
  function rinde(p) {
    var a = ml(p.tamano), b = p.grande && ml(p.grande.tamano);
    if (!a || !b) return null;
    var f = b / a;
    return f >= 1.5 ? Math.round(f * 10) / 10 : null;
  }

  /* El kit sólo aplica cuando la rutina YA recomendó los dos pasos que trae y
     los dos están en su tamaño normal. Si el usuario se llevó uno a 1 L, el kit
     deja de ser equivalente y desaparece: si no, el resumen mentiría. */
  function kitAplicable() {
    var conKit = pasosActuales.filter(function (x) {
      return x.producto && x.producto.kit && eleccion[x.sku] !== 'grande';
    });
    if (conKit.length < 2) return null;
    var k = conKit[0].producto.kit;
    var mismos = conKit.every(function (x) { return x.producto.kit.sku === k.sku; });
    if (!mismos || !k.disponible) return null;
    var suelto = conKit.reduce(function (a, x) { return a + x.producto.precio; }, 0);
    return { kit: k, pasos: conKit, suelto: suelto };
  }

  function repintarResultado() {
    var ritual = raiz.querySelector('[data-dx-ritual]');
    var campos = raiz.querySelector('[data-dx-campos]');
    var boton = raiz.querySelector('[data-dx-anadir]');
    var resumen = raiz.querySelector('[data-dx-resumen]');

    var combo = kitAplicable();
    if (!combo) kitPuesto = false;
    var consolidados = kitPuesto && combo ? combo.pasos.map(function (x) { return x.sku; }) : [];

    ritual.innerHTML = '';
    campos.innerHTML = '';
    var total = 0, lineas = 0, n = 0;

    pasosActuales.forEach(function (paso) {
      var p = paso.producto;
      var li = document.createElement('li');
      li.className = 'fx-dx__paso-item';
      n += 1;
      var rot = ('0' + n).slice(-2) + ' · ' + (ROTULOS[paso.clave] || '');

      if (!p) {
        li.innerHTML = '<span class="fx-dx__n">' + rot + '</span>' +
          '<div class="fx-dx__sinprod">Este paso lo cubre un producto que hoy no está en la tienda en línea. ' +
          'Pregúntalo en tu salón Framesi.</div>';
        ritual.appendChild(li);
        return;
      }

      var enKit = consolidados.indexOf(paso.sku) >= 0;
      var grande = eleccion[paso.sku] === 'grande' && p.grande;
      var elegido = grande ? p.grande : p;
      var agotado = !elegido.disponible;

      if (!enKit && !agotado) {
        total += elegido.precio;
        campos.insertAdjacentHTML('beforeend',
          '<input type="hidden" name="items[' + lineas + '][id]" value="' + elegido.variante + '">' +
          '<input type="hidden" name="items[' + lineas + '][quantity]" value="1">');
        lineas += 1;
      }

      var veces = rinde(p);
      var selector = '';
      if (p.grande && p.grande.disponible && p.disponible && !enKit) {
        selector =
          '<div class="fx-dx__tam" role="group" aria-label="Tamaño de ' + p.titulo + '">' +
            '<button type="button" data-dx-tam="normal" data-sku="' + paso.sku + '" aria-pressed="' + (!grande) + '">' +
              (p.tamano || 'Normal') + ' · ' + p.precio_txt + '</button>' +
            '<button type="button" data-dx-tam="grande" data-sku="' + paso.sku + '" aria-pressed="' + (!!grande) + '">' +
              (p.grande.tamano || '1 L') + ' · ' + p.grande.precio_txt +
              (veces ? '<span class="fx-dx__rinde">rinde ' + veces + '×</span>' : '') +
            '</button>' +
          '</div>';
      }

      li.innerHTML =
        '<span class="fx-dx__n">' + rot + (enKit ? ' <i class="fx-dx__enkit">en el kit</i>' : '') + '</span>' +
        '<a class="fx-dx__ficha' + (enKit ? ' esta-en-kit' : '') + '" href="' + elegido.url + '">' +
          (p.img ? '<img src="' + p.img + '" alt="" loading="lazy" width="72" height="72">' : '') +
          '<span class="fx-dx__tx">' +
            '<b>' + elegido.titulo + '</b>' +
            '<span class="fx-dx__meta">' + (agotado ? 'Agotado' : elegido.precio_txt) + '</span>' +
          '</span>' +
        '</a>' + selector;
      ritual.appendChild(li);
    });

    /* ---- la tarjeta del kit, después de los pasos que consolida ---- */
    if (combo) {
      if (kitPuesto) {
        total += combo.kit.precio;
        campos.insertAdjacentHTML('beforeend',
          '<input type="hidden" name="items[' + lineas + '][id]" value="' + combo.kit.variante + '">' +
          '<input type="hidden" name="items[' + lineas + '][quantity]" value="1">');
        lineas += 1;
      }
      var igual = combo.kit.precio === combo.suelto;
      var li = document.createElement('li');
      li.className = 'fx-dx__paso-item fx-dx__kit';
      li.innerHTML =
        '<label class="fx-dx__kit-caja">' +
          '<input type="checkbox" data-dx-kit ' + (kitPuesto ? 'checked' : '') + '>' +
          '<span>' +
            '<b>Esos dos pasos vienen en un solo kit</b>' +
            '<span class="fx-dx__kit-nota">' + combo.kit.titulo + ' · ' + combo.kit.precio_txt +
            (igual ? ' — el mismo precio que por separado, en un solo empaque.' : '') + '</span>' +
          '</span>' +
        '</label>';
      ritual.appendChild(li);
    }

    resumen.textContent = 'Tu rutina: ' + pasosActuales.length + ' paso' +
      (pasosActuales.length === 1 ? '' : 's') + ', según el protocolo Framesi para lo que nos dijiste.';

    if (lineas > 0) {
      boton.hidden = false;
      boton.textContent = 'Añadir ' + (lineas === 1 ? 'el producto' : 'los ' + lineas) + ' · ' + formatoMXN(total);
    } else {
      boton.hidden = true;
    }
  }

  function mostrarResultado() {
    pasosActuales = resolver();
    eleccion = {};
    // Si solo el tamaño normal está agotado, queda elegido el de 1 L.
    pasosActuales.forEach(function (x) {
      var p = x.producto;
      if (p && !p.disponible && p.grande && p.grande.disponible) eleccion[x.sku] = 'grande';
    });
    kitPuesto = false;
    ver(panel, false);
    ver(resultado, true);
    repintarResultado();
  }

  function formatoMXN(centavos) {
    var v = centavos / 100;
    /* sin `minimumFractionDigits` el formateador escribe «$1,741.8»: los centavos
       sólo cuando los hay, como hace `money_without_trailing_zeros` */
    var tieneCent = Math.round(v * 100) % 100 !== 0;
    return '$' + v.toLocaleString('es-MX', {
      minimumFractionDigits: tieneCent ? 2 : 0,
      maximumFractionDigits: tieneCent ? 2 : 0
    });
  }

  function empezar() {
    if (REGLAS) { ver(intro, false); ver(panel, true); pintar(); return; }
    fetch(raiz.dataset.reglas)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        REGLAS = d;
        ver(intro, false); ver(panel, true); pintar();
      })
      .catch(function (e) {
        console.error('Diagnóstico: no se pudieron cargar las reglas', e);
        var b = raiz.querySelector('[data-dx-empezar]');
        if (b) b.textContent = 'No se pudo cargar. Recarga la página.';
      });
  }

  raiz.addEventListener('change', function (e) {
    if (e.target.closest('[data-dx-kit]')) {
      kitPuesto = e.target.checked;
      repintarResultado();
    }
  });

  raiz.addEventListener('click', function (e) {
    if (e.target.closest('[data-dx-empezar]')) { e.preventDefault(); empezar(); return; }
    if (e.target.closest('[data-dx-atras]')) {
      e.preventDefault();
      if (indice > 0) { indice -= 1; pintar(); }
      return;
    }
    var tam = e.target.closest('[data-dx-tam]');
    if (tam) {
      e.preventDefault();
      eleccion[tam.dataset.sku] = tam.dataset.dxTam;
      repintarResultado();
      return;
    }
    if (e.target.closest('[data-dx-reiniciar]')) {
      e.preventDefault();
      respuestas = {}; indice = 0;
      ver(resultado, false); ver(panel, true); pintar();
    }
  });
})();
